module.exports = __webpack_public_path__ + "img/lucas-mccallum-portrait-2.edd17922.jpg";